import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=1f5fbcb1"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"
import style0 from "./change-password.vue?vue&type=style&index=0&id=1f5fbcb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports